export function exportTextures(context, channelIndex = null, options = {}) {
    const sanitize = (s) => String(s).replace(/[^\w-]+/g, '_');
    const optMap = options?.udimNameMap;
    const defaultMap = { 1001: 'Head', 1002: 'Upper Body', 1003: 'Lower Body', 1004: 'Ears' };
    const map = optMap || (context?.udimNameMap ? context.udimNameMap : (context?.isDefaultMesh ? defaultMap : null));
    const makeFileBase = (tile) => (map && map[tile]) ? map[tile] : `udim_${tile}`;

    if (typeof channelIndex === 'number') {
        const ch = context.uvChannels[channelIndex];
        if (ch) {
            const base = makeFileBase(ch.udimTile);
            const link = document.createElement('a');
            link.download = `${sanitize(base)}.png`;
            const useComposite = options?.mode === 'composite';
            link.href = (useComposite ? ch.compositeCanvas : ch.decalCanvas).toDataURL('image/png');
            link.click();
        }
    } else {
        context.uvChannels.forEach((ch) => {
            if (ch) {
                const base = makeFileBase(ch.udimTile);
                const link = document.createElement('a');
                link.download = `${sanitize(base)}.png`;
                const useDecal = options?.mode === 'decal';
                link.href = (useDecal ? ch.decalCanvas : ch.compositeCanvas).toDataURL('image/png');
                link.click();
            }
        });
        context.updateStatus('Textures exported');
    }
}
